var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_radio"},[_c('input',{ref:"radio",attrs:{"type":"radio","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.onChange()}}}),_c('label',{class:{
      checked: _vm.checked,
      disabled: _vm.disabled,
    },attrs:{"for":_vm.id},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }